import * as React from 'react';

export const FeedbackTab = () => {
  return <div>TBA tab content: FeedbackTab</div>;
};
